<template>
  <v-container class="py-0">
    <v-row justify="center">
      <v-col :cols="12" :sm="10" :md="10" :lg="11" :xl="11" class="py-0 px-0">
        <v-card flat scrollable>
          <v-container class="pt-7 pb-2">
            <v-card class="d-flex justify-space-between" flat>
              <span
                style="color:#444444; font-family: explorerTitleFont;font-size:20px;font-weight:600;"
                >Transactions</span
              >
              <!-- <v-menu offset-y min-width="100">
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                text
                height="25"
                style="min-width:0px !important; padding:0px !important;"
                v-on="on"
              >
                <span class="original-text-button text-capitalize">{{
                  type
                }}</span>
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense class="color:primary">
              <v-list-item
                v-for="(item, index) in txTypes"
                :key="index"
                @click="searchByType(item)"
              >
                <v-list-item-title>
                  <span :class="menuItemFontColor(item)">{{ item }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
              </v-menu>-->
            </v-card>
          </v-container>
          <v-container>
            <expand-table
              :prop-limit="limit"
              :apiUrl="apiUrl"
              :params="txParams"
              :links="links"
              :attributes="attributes"
              :order="order"
              :subtile="subtile"
              :infiniteLoading="true"
              ref="txTable"
              class="pt-0"
            />
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ExpandTable from "../material/ExpandTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    ExpandTable
  },
  data() {
    return {
      type: "all",
      txTypes: [
        "all",
        "init",
        "supercede",
        "send",
        "issue",
        "destroy",
        "canSplit"
      ],
      attributes: [
        { text: "ID", value: "transactionId" },
        { text: "Amount", value: "amount" }
      ],
      subtile: {
        transactionId: {
          type: "prop",
          property: "timestamp",
          propType: "timestamp",
          text: "ID"
        },
        timestamp: { type: "timestamp", text: "Time" },
        amount: {
          type: "transform_unity",
          text: "Amount",
          mobileHidden: true,
          align: "right"
        },
        signer: { type: "address", text: "Sender" },
        // functionIndexType: { type: "text", text: "Type" },
        recipient: { type: "address", text: "Recipient" },
        status: { type: "status", text: "Status" },
        height: {
          type: "thousands",
          text: "Block Height",
          computerHidden: true
        }
      },
      order: ["signer", "recipient", "status", "height"],
      limit: 10,
      apiUrl: `${this.$config.apiEndPoint}/token/transactions`,
      links: {
        transactionId: "/transaction/:transactionId",
        signer: "/address/:address",
        recipient: "/address/:address"
      },
      txParams: {}
    };
  },
  computed: {
    ...mapState(["tokenId"])
  },
  created() {
    this.txParams.tokenId = this.tokenId;
  },
  methods: {
    menuItemFontColor(item) {
      return this.type === item
        ? "primary--text text-capitalize"
        : "text-capitalize";
    },
    searchByType(type) {
      //v-input__icon // .v-input
      this.type = type;
      this.$refs.txTable.searchByType(type);
    }
  }
};
</script>
<style>
.v-input_tx-type {
  font-size: 13px;
}
.v-input__icon_v-input_tx-type {
  width: 16px;
  min-width: 16px;
}
.original-text-button {
  text-transform: none;
}
@font-face {
  /* font-properties */
  font-family: explorerTitleFont;
  src: url("../../assets/font/SF-Pro-Display-Semibold.otf");
}
</style>
